// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1LLL1","title":"Header_title__2_41H","side":"Header_side__dHev_"};